/*
 * File: /src/router/routes/events.js
 * Created Date: Tuesday May 17th 2022
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 17th May 2022 9:08:38 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2022 AdBase, Inc.
 */

const EventLogViewer = () =>
  import(
    /* webpackChunkName: "Events" */ 'src/components/Dashboard/Views/Events/EventLogViewer.vue'
  );

export const eventRoutes = [
  {
    path: 'events/:eventType',
    name: 'Event Log Viewer',
    component: EventLogViewer,
  },
];
